import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { useAvailability } from '../../utils/availability'
import { useGetCart } from '../CartQuery/CartQuery'

import CartUnavailable from '../../assets/cart-unavailable.svg'
import CartImg from '../../assets/cart.svg'

import './CartIcon.css'

export const CartIcon = ({ showCount, variant }) => {
  const { error, loading: cartLoading, cart } = useGetCart()
  const { orderingAvailable, loading: availabilityLoading } = useAvailability()
  const loading = (cartLoading || availabilityLoading)

  if (loading) return null

  const numberOfSelections = cart ? cart.order.numberOfSelections : 0
  const cartAvailable = orderingAvailable && !error

  return (
    <div styleName={cx('cart', variant)}>
      { cartAvailable
        ? <CartImg styleName='cartImage' data-testid='cart-available' />
        : <CartUnavailable styleName='cartImage' data-testid='cart-unavailable' />
      }
      {numberOfSelections > 0 && showCount && (
        <span styleName='quantity'>{numberOfSelections}</span>
      )}
    </div>)
}

CartIcon.propTypes = {
  showCount: PropTypes.bool,
  variant: PropTypes.oneOf(['light'])
}

export default CartIcon
